import {OperatingSystemType} from '@toolify/server/src/controllers/NativeAppController/enum/OperatingSystemType'
import {OperatingSystemArchitecture} from '@toolify/server/src/controllers/NativeAppController/enum/OperatingSystemArchitecture'

export function useOperatingSystem() {
  const getOperatingSystem = () => {
    const userAgent = window.navigator.userAgent,
      platform = window.navigator.platform,
      macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
      windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
      iosPlatforms = ['iPhone', 'iPad', 'iPod']
    if (macosPlatforms.indexOf(platform) !== -1) {
      return OperatingSystemType.Mac
    } else if (iosPlatforms.indexOf(platform) !== -1) {
      return OperatingSystemType.IOs
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
      return OperatingSystemType.Windows
    } else if (/Android/.test(userAgent)) {
      return OperatingSystemType.Android
    } else if (/Linux/.test(platform)) {
      return OperatingSystemType.Linux
    }
    return null
  }

  const getOperatingSystemArchitecture = async (): Promise<OperatingSystemArchitecture | null> => {
    try {
      // Use User-Agent Client Hints API if available
      interface NavigatorWithUAData {
        userAgentData?: {
          getHighEntropyValues: (hints: string[]) => Promise<{ architecture?: string }>
        }
      }
      const nav = window.navigator as unknown as NavigatorWithUAData

      if (nav.userAgentData && nav.userAgentData.getHighEntropyValues) {
        const values = await nav.userAgentData.getHighEntropyValues(['architecture'])
        // the API usually returns 'arm' for ARM architectures on macOS/Windows
        if (values.architecture === 'arm') {
          return OperatingSystemArchitecture.Arm64
        } else if (values.architecture === 'x86') {
          return OperatingSystemArchitecture.X64
        }
      }
    } catch {
      // Fail gracefully
    }

    try {
      // WebGL detection fallback, mainly for Safari which doesn't support Client Hints but does expose the renderer
      const canvas = document.createElement('canvas')
      const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl')
      if (gl) {
        const debugInfo = (gl as WebGLRenderingContext).getExtension('WEBGL_debug_renderer_info')
        if (debugInfo) {
          const renderer = (gl as WebGLRenderingContext).getParameter(debugInfo.UNMASKED_RENDERER_WEBGL)
          if (renderer && typeof renderer === 'string') {
            if (renderer.includes('Apple M') || renderer.includes('Apple A')) {
              return OperatingSystemArchitecture.Arm64
            } else if (renderer.includes('Intel') || renderer.includes('AMD')) {
              return OperatingSystemArchitecture.X64
            }
          }
        }
      }
    } catch {
      // Fail gracefully
    }

    return null
  }

  return {
    getOperatingSystem,
    getOperatingSystemArchitecture,
  }
}
